export default __webpack_public_path__ + "static/media/japantrad4.16ccddcc.png";